import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { MetaProvider } from "@/context/MetaContext";

export default function Layout() {
  const [open, setOpen] = useState(false);
  return (
    <MetaProvider>
      <div className="min-h-screen bg-background">
        <Sidebar open={open} onClose={() => setOpen(false)} />
        <div className="lg:pl-[250px]">
          <Topbar onMenu={() => setOpen(true)} />
          <main className="mx-auto max-w-[1500px] p-4 sm:p-6 lg:p-8">
            <Outlet />
          </main>
        </div>
      </div>
    </MetaProvider>
  );
}
